<template>
    <aside class="col-sm-3">
        <div v-if="typeof(deptInfo) == 'undefined' && overviewLinks.length > 0" >
            <h3>Resources</h3>
            <ul>
                <li v-for="(link, index) in overviewLinks" :key="index">
                    <a :href="link.url">{{ link.name }}</a>
                </li>
            </ul>
        </div>
        <div v-if="typeof(deptInfo) !== 'undefined' && years.length > 0" class="deptInfo">
            <h3><a :href="urls.website">{{ deptInfo.department_or_fund_name }}</a></h3>
            <p>{{ deptInfo.department_director_name }}, {{ deptInfo.department_director_title }}</p>
            <p>{{ deptInfo.department_or_fund_description }}</p>
     
                <p v-if="budget">
                    <strong>{{ mainBudget.when }} Budget: </strong><br/> 
                    {{ budget | toCurrency  }}
                </p>
                <p v-if="ftes">
                    <strong>{{ mainBudget.when }} FTE: </strong><br/> 
                    {{ ftes }}
                </p>
                <p><strong>Department Budget Links</strong></p>
                <ul>
                    <li><a :href="urls.budgetBook" target="_blank">Budget Book</a></li>
                </ul>
        </div>
    </aside>
</template>

<script>
    export default {
        name: 'Sidebar',
        props: {
            'years' : Array,
            'mainBudget' : Object,
            'deptInfo' : Object
        },
        computed: {
            overviewLinks: function(){
                return (this.mainBudget.overview.links) ? this.mainBudget.overview.links : []
            },
            urls: function() {
                let urls = {};

                urls.website = this.getURL(this.deptInfo.department_website) || '';
                urls.budgetBook = this.getURL(this.deptInfo.department_budget_book) || '';

                return urls;
            },
            budget: function(){
                return this.getProperty('_budget');
            },
            ftes: function(){
                return this.getProperty('_fte');
            }
        },
        methods: {
            getProperty: function(propName){
                let prop = '';

                if (this.years) {
                    this.years.forEach((year)=>{
                        let yearProp = this.deptInfo[year + propName];
                        
                        if (yearProp) prop = yearProp;
                    });
                }
                
                return prop;
            },
            getURL: function(item){ /* This is a fix for Socrata's intermittent nesting of urls as object properties */
                let url = item;

                if (typeof(item) === 'object') {
                    url = (item.url) ? item.url : '';
                }

                return url;
            }
        }
    }
</script>